import React from 'react';
import { Person } from '../../../models';
import { Input } from '../../inputs';

interface PersonFormProps {
  id: string;
  person: Person;
  setPeople: React.Dispatch<React.SetStateAction<Person[]>>;
  isReadOnly?: boolean;
}

export default function PersonForm({
  id,
  person: _person,
  setPeople,
  isReadOnly = false,
}: PersonFormProps) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPeople((people) => {
      const idx = people?.findIndex((person) => person.id === id) ?? -1;
      if (idx === -1) {
        return people;
      }
      return [
        ...(people?.slice(0, idx) ?? []),
        { ...people[idx], [name]: value },
        ...(people?.slice(idx + 1) ?? []),
      ];
    });
  };

  return (
    <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div className="col-span-2">
        <Input
          type="text"
          label="Name"
          name="name"
          placeholder="Name"
          value={_person?.name}
          onChange={onChange}
          readOnly={isReadOnly}
          disabled={isReadOnly}
        />
      </div>
      <Input
        type="text"
        label="Position"
        name="position"
        placeholder="Position"
        value={_person?.position}
        onChange={onChange}
        readOnly={isReadOnly}
        disabled={isReadOnly}
      />
      <Input
        type="text"
        label="Institution"
        name="institution"
        placeholder="Institution"
        value={_person?.institution}
        onChange={onChange}
        readOnly={isReadOnly}
        disabled={isReadOnly}
      />
      <div className="col-span-2">
        <Input
          type="text"
          label="Address"
          name="address"
          placeholder="Address"
          value={_person?.address}
          onChange={onChange}
          readOnly={isReadOnly}
          disabled={isReadOnly}
        />
      </div>
      <div className="col-span-2">
        <Input
          type="tel"
          label="Telephone"
          name="phone"
          placeholder="Telephone"
          value={_person?.phone}
          onChange={onChange}
          readOnly={isReadOnly}
          disabled={isReadOnly}
        />
      </div>
    </div>
  );
}
